import { Route, Routes, useNavigate } from "react-router-dom";
import { RoomManager } from "./Components/RoomManager";
import { WorkspaceMap } from "./Components/workspaceMap";
import { AssigmentTable } from "./Components/assigenmentTable";
import { BookingCalendar } from "./Components/bookingCalendar";
import { ManagementWorkspace } from "./Components/managementWorkspace";
import { BookingTable } from "./Components/bookingTable";
import { RoomReservations } from "./Components/RoomReservations";

export const WorkspaceRouting = () => {
    useNavigate();
    return (
        <Routes>
            <Route path="" element={ <WorkspaceMap/> }/>
            <Route path="rooms" element={ <RoomManager/> }/>
            <Route path="map" element={ <WorkspaceMap/> }/>
            <Route path="assignmentTable" element={ <AssigmentTable/> }/>
            <Route path="bookingCalendar" element={ <BookingCalendar roomId={ "" } roomName={ "" }/> }/>
            <Route path="management" element={ <ManagementWorkspace/> }/>
            <Route path="bookings" element={ <BookingTable/> }/>
            <Route path="meetingRooms" element={ <RoomReservations/> }/>
        </Routes>
    );
};